const WEBAPP_URL =
  "https://script.google.com/macros/s/AKfycbzWRo6-91eSgS-gW2o6LsG-GRALhjittqKqfuCvMmlhgiZ_y7wijgKwvofwgU2mwGBU/exec";

export function logToSheet(email, context) {
  return new Promise((resolve) => {
    const cb = "cb" + Date.now();
    window[cb] = (data) => {
      console.log("Sheet OK:", data);
      resolve(data);
      delete window[cb];
    };
    const script = document.createElement("script");
    script.src =
      `${WEBAPP_URL}` +
      `?callback=${cb}` +
      `&email=${encodeURIComponent(email)}` +
      `&context=${context}`;
    document.body.appendChild(script);
    setTimeout(() => document.body.removeChild(script), 5000);
  });
}
